[
  {
    "country": "Afghanistan",
    "countryCodes": ["93"],
    "isoCode2": "AF",
    "isoCode3": "AFG",
    "phLength": 9
  },
  {
    "country": "Albania",
    "countryCodes": ["355"],
    "isoCode2": "AL",
    "isoCode3": "ALB",
    "phLength": 9
  },
  {
    "country": "Algeria",
    "countryCodes": ["213"],
    "isoCode2": "DZ",
    "isoCode3": "DZA",
    "phLength": 9
  },
  {
    "country": "American Samoa",
    "countryCodes": ["1-684"],
    "isoCode2": "AS",
    "isoCode3": "ASM",
    "phLength": 10
  },
  {
    "country": "Andorra",
    "countryCodes": ["376"],
    "isoCode2": "AD",
    "isoCode3": "AND",
    "phLength": 9
  },
  {
    "country": "Angola",
    "countryCodes": ["244"],
    "isoCode2": "AO",
    "isoCode3": "AGO",
    "phLength": 9
  },
  {
    "country": "Anguilla",
    "countryCodes": ["1-264"],
    "isoCode2": "AI",
    "isoCode3": "AIA",
    "phLength": 10
  },
  {
    "country": "Antarctica",
    "countryCodes": ["672"],
    "isoCode2": "AQ",
    "isoCode3": "ATA"
  },
  {
    "country": "Antigua and Barbuda",
    "countryCodes": ["1-268"],
    "isoCode2": "AG",
    "isoCode3": "ATG",
    "phLength": 10
  },
  {
    "country": "Argentina",
    "countryCodes": ["54"],
    "isoCode2": "AR",
    "isoCode3": "ARG",
    "phLength": 10
  },
  {
    "country": "Armenia",
    "countryCodes": ["374"],
    "isoCode2": "AM",
    "isoCode3": "ARM",
    "phLength": 8
  },
  {
    "country": "Aruba",
    "countryCodes": ["297"],
    "isoCode2": "AW",
    "isoCode3": "ABW",
    "phLength": 7
  },
  {
    "country": "Australia",
    "countryCodes": ["61"],
    "isoCode2": "AU",
    "isoCode3": "AUS",
    "phLength": 9
  },
  {
    "country": "Austria",
    "countryCodes": ["43"],
    "isoCode2": "AT",
    "isoCode3": "AUT",
    "phLength": 10
  },
  {
    "country": "Azerbaijan",
    "countryCodes": ["994"],
    "isoCode2": "AZ",
    "isoCode3": "AZE",
    "phLength": 9
  },
  {
    "country": "Bahamas",
    "countryCodes": ["1-242"],
    "isoCode2": "BS",
    "isoCode3": "BHS",
    "phLength": 10
  },
  {
    "country": "Bahrain",
    "countryCodes": ["973"],
    "isoCode2": "BH",
    "isoCode3": "BHR",
    "phLength": 8
  },
  {
    "country": "Bangladesh",
    "countryCodes": ["880"],
    "isoCode2": "BD",
    "isoCode3": "BGD",
    "phLength": 10
  },
  {
    "country": "Barbados",
    "countryCodes": ["1-246"],
    "isoCode2": "BB",
    "isoCode3": "BRB",
    "phLength": 10
  },
  {
    "country": "Belarus",
    "countryCodes": ["375"],
    "isoCode2": "BY",
    "isoCode3": "BLR",
    "phLength": 9
  },
  {
    "country": "Belgium",
    "countryCodes": ["32"],
    "isoCode2": "BE",
    "isoCode3": "BEL",
    "phLength": 9
  },
  {
    "country": "Belize",
    "countryCodes": ["501"],
    "isoCode2": "BZ",
    "isoCode3": "BLZ",
    "phLength": 7
  },
  {
    "country": "Benin",
    "countryCodes": ["229"],
    "isoCode2": "BJ",
    "isoCode3": "BEN",
    "phLength": 9
  },
  {
    "country": "Bermuda",
    "countryCodes": ["1-441"],
    "isoCode2": "BM",
    "isoCode3": "BMU",
    "phLength": 10
  },
  {
    "country": "Bhutan",
    "countryCodes": ["975"],
    "isoCode2": "BT",
    "isoCode3": "BTN",
    "phLength": 8
  },
  {
    "country": "Bolivia",
    "countryCodes": ["591"],
    "isoCode2": "BO",
    "isoCode3": "BOL",
    "phLength": 8
  },
  {
    "country": "Bosnia and Herzegovina",
    "countryCodes": ["387"],
    "isoCode2": "BA",
    "isoCode3": "BIH",
    "phLength": 8
  },
  {
    "country": "Botswana",
    "countryCodes": ["267"],
    "isoCode2": "BW",
    "isoCode3": "BWA",
    "phLength": 8
  },
  {
    "country": "Brazil",
    "countryCodes": ["55"],
    "isoCode2": "BR",
    "isoCode3": "BRA",
    "phLength": 11
  },
  {
    "country": "British Indian Ocean Territory",
    "countryCodes": ["246"],
    "isoCode2": "IO",
    "isoCode3": "IOT"
  },
  {
    "country": "British Virgin Islands",
    "countryCodes": ["1-284"],
    "isoCode2": "VG",
    "isoCode3": "VGB",
    "phLength": 10
  },
  {
    "country": "Brunei",
    "countryCodes": ["673"],
    "isoCode2": "BN",
    "isoCode3": "BRN",
    "phLength": 7
  },
  {
    "country": "Bulgaria",
    "countryCodes": ["359"],
    "isoCode2": "BG",
    "isoCode3": "BGR",
    "phLength": 9
  },
  {
    "country": "Burkina Faso",
    "countryCodes": ["226"],
    "isoCode2": "BF",
    "isoCode3": "BFA",
    "phLength": 8
  },
  {
    "country": "Burundi",
    "countryCodes": ["257"],
    "isoCode2": "BI",
    "isoCode3": "BDI",
    "phLength": 8
  },
  {
    "country": "Cambodia",
    "countryCodes": ["855"],
    "isoCode2": "KH",
    "isoCode3": "KHM",
    "phLength": 9
  },
  {
    "country": "Cameroon",
    "countryCodes": ["237"],
    "isoCode2": "CM",
    "isoCode3": "CMR",
    "phLength": 9
  },
  {
    "country": "Canada",
    "countryCodes": ["1"],
    "isoCode2": "CA",
    "isoCode3": "CAN",
    "phLength": 10
  },
  {
    "country": "Cape Verde",
    "countryCodes": ["238"],
    "isoCode2": "CV",
    "isoCode3": "CPV",
    "phLength": 7
  },
  {
    "country": "Cayman Islands",
    "countryCodes": ["1-345"],
    "isoCode2": "KY",
    "isoCode3": "CYM",
    "phLength": 10
  },
  {
    "country": "Central African Republic",
    "countryCodes": ["236"],
    "isoCode2": "CF",
    "isoCode3": "CAF",
    "phLength": 8
  },
  {
    "country": "Chad",
    "countryCodes": ["235"],
    "isoCode2": "TD",
    "isoCode3": "TCD",
    "phLength": 8
  },
  {
    "country": "Chile",
    "countryCodes": ["56"],
    "isoCode2": "CL",
    "isoCode3": "CHL",
    "phLength": 9
  },
  {
    "country": "China",
    "countryCodes": ["86"],
    "isoCode2": "CN",
    "isoCode3": "CHN",
    "phLength": 13
  },
  {
    "country": "Christmas Island",
    "countryCodes": ["61"],
    "isoCode2": "CX",
    "isoCode3": "CXR"
  },
  {
    "country": "Cocos Islands",
    "countryCodes": ["61"],
    "isoCode2": "CC",
    "isoCode3": "CCK"
  },
  {
    "country": "Colombia",
    "countryCodes": ["57"],
    "isoCode2": "CO",
    "isoCode3": "COL",
    "phLength": 10
  },
  {
    "country": "Comoros",
    "countryCodes": ["269"],
    "isoCode2": "KM",
    "isoCode3": "COM",
    "phLength": 7
  },
  {
    "country": "Cook Islands",
    "countryCodes": ["682"],
    "isoCode2": "CK",
    "isoCode3": "COK",
    "phLength": 5
  },
  {
    "country": "Costa Rica",
    "countryCodes": ["506"],
    "isoCode2": "CR",
    "isoCode3": "CRI",
    "phLength": 8
  },
  {
    "country": "Croatia",
    "countryCodes": ["385"],
    "isoCode2": "HR",
    "isoCode3": "HRV",
    "phLength": 9
  },
  {
    "country": "Cuba",
    "countryCodes": ["53"],
    "isoCode2": "CU",
    "isoCode3": "CUB",
    "phLength": 8
  },
  {
    "country": "Curacao",
    "countryCodes": ["599"],
    "isoCode2": "CW",
    "isoCode3": "CUW"
  },
  {
    "country": "Cyprus",
    "countryCodes": ["357"],
    "isoCode2": "CY",
    "isoCode3": "CYP",
    "phLength": 8
  },
  {
    "country": "Czech Republic",
    "countryCodes": ["420"],
    "isoCode2": "CZ",
    "isoCode3": "CZE",
    "phLength": 9
  },
  {
    "country": "Democratic Republic of the Congo",
    "countryCodes": ["243"],
    "isoCode2": "CD",
    "isoCode3": "COD"
  },
  {
    "country": "Denmark",
    "countryCodes": ["45"],
    "isoCode2": "DK",
    "isoCode3": "DNK",
    "phLength": 8
  },
  {
    "country": "Djibouti",
    "countryCodes": ["253"],
    "isoCode2": "DJ",
    "isoCode3": "DJI",
    "phLength": 6
  },
  {
    "country": "Dominica",
    "countryCodes": ["1-767"],
    "isoCode2": "DM",
    "isoCode3": "DMA",
    "phLength": 10
  },
  {
    "country": "Dominican Republic",
    "countryCodes": ["1-809", "1-829", "1-849"],
    "isoCode2": "DO",
    "isoCode3": "DOM",
    "phLength": 10
  },
  {
    "country": "East Timor",
    "countryCodes": ["670"],
    "isoCode2": "TL",
    "isoCode3": "TLS"
  },
  {
    "country": "Ecuador",
    "countryCodes": ["593"],
    "isoCode2": "EC",
    "isoCode3": "ECU",
    "phLength": 9
  },
  {
    "country": "Egypt",
    "countryCodes": ["20"],
    "isoCode2": "EG",
    "isoCode3": "EGY",
    "phLength": 10
  },
  {
    "country": "El Salvador",
    "countryCodes": ["503"],
    "isoCode2": "SV",
    "isoCode3": "SLV",
    "phLength": 8
  },
  {
    "country": "Equatorial Guinea",
    "countryCodes": ["240"],
    "isoCode2": "GQ",
    "isoCode3": "GNQ",
    "phLength": 6
  },
  {
    "country": "Eritrea",
    "countryCodes": ["291"],
    "isoCode2": "ER",
    "isoCode3": "ERI",
    "phLength": 7
  },
  {
    "country": "Estonia",
    "countryCodes": ["372"],
    "isoCode2": "EE",
    "isoCode3": "EST",
    "phLength": 8
  },
  {
    "country": "Ethiopia",
    "countryCodes": ["251"],
    "isoCode2": "ET",
    "isoCode3": "ETH",
    "phLength": 9
  },
  {
    "country": "Falkland Islands",
    "countryCodes": ["500"],
    "isoCode2": "FK",
    "isoCode3": "FLK",
    "phLength": 5
  },
  {
    "country": "Faroe Islands",
    "countryCodes": ["298"],
    "isoCode2": "FO",
    "isoCode3": "FRO",
    "phLength": 5
  },
  {
    "country": "Fiji",
    "countryCodes": ["679"],
    "isoCode2": "FJ",
    "isoCode3": "FJI",
    "phLength": 7
  },
  {
    "country": "Finland",
    "countryCodes": ["358"],
    "isoCode2": "FI",
    "isoCode3": "FIN",
    "phLength": 12
  },
  {
    "country": "France",
    "countryCodes": ["33"],
    "isoCode2": "FR",
    "isoCode3": "FRA",
    "phLength": 9
  },
  {
    "country": "French Polynesia",
    "countryCodes": ["689"],
    "isoCode2": "PF",
    "isoCode3": "PYF",
    "phLength": 6
  },
  {
    "country": "Gabon",
    "countryCodes": ["241"],
    "isoCode2": "GA",
    "isoCode3": "GAB",
    "phLength": 7
  },
  {
    "country": "Gambia",
    "countryCodes": ["220"],
    "isoCode2": "GM",
    "isoCode3": "GMB",
    "phLength": 7
  },
  {
    "country": "Georgia",
    "countryCodes": ["995"],
    "isoCode2": "GE",
    "isoCode3": "GEO",
    "phLength": 9
  },
  {
    "country": "Germany",
    "countryCodes": ["49"],
    "isoCode2": "DE",
    "isoCode3": "DEU",
    "phLength": 10
  },
  {
    "country": "Ghana",
    "countryCodes": ["233"],
    "isoCode2": "GH",
    "isoCode3": "GHA",
    "phLength": 9
  },
  {
    "country": "Gibraltar",
    "countryCodes": ["350"],
    "isoCode2": "GI",
    "isoCode3": "GIB",
    "phLength": 8
  },
  {
    "country": "Greece",
    "countryCodes": ["30"],
    "isoCode2": "GR",
    "isoCode3": "GRC",
    "phLength": 10
  },
  {
    "country": "Greenland",
    "countryCodes": ["299"],
    "isoCode2": "GL",
    "isoCode3": "GRL",
    "phLength": 6
  },
  {
    "country": "Grenada",
    "countryCodes": ["1-473"],
    "isoCode2": "GD",
    "isoCode3": "GRD",
    "phLength": 10
  },
  {
    "country": "Guam",
    "countryCodes": ["1-671"],
    "isoCode2": "GU",
    "isoCode3": "GUM",
    "phLength": 10
  },
  {
    "country": "Guatemala",
    "countryCodes": ["502"],
    "isoCode2": "GT",
    "isoCode3": "GTM",
    "phLength": 8
  },
  {
    "country": "Guernsey",
    "countryCodes": ["44-1481"],
    "isoCode2": "GG",
    "isoCode3": "GGY",
    "phLength": 10
  },
  {
    "country": "Guinea",
    "countryCodes": ["224"],
    "isoCode2": "GN",
    "isoCode3": "GIN",
    "phLength": 8
  },
  {
    "country": "Guinea-Bissau",
    "countryCodes": ["245"],
    "isoCode2": "GW",
    "isoCode3": "GNB",
    "phLength": 7
  },
  {
    "country": "Guyana",
    "countryCodes": ["592"],
    "isoCode2": "GY",
    "isoCode3": "GUY",
    "phLength": 7
  },
  {
    "country": "Haiti",
    "countryCodes": ["509"],
    "isoCode2": "HT",
    "isoCode3": "HTI",
    "phLength": 8
  },
  {
    "country": "Honduras",
    "countryCodes": ["504"],
    "isoCode2": "HN",
    "isoCode3": "HND",
    "phLength": 8
  },
  {
    "country": "Hong Kong",
    "countryCodes": ["852"],
    "isoCode2": "HK",
    "isoCode3": "HKG",
    "phLength": 8
  },
  {
    "country": "Hungary",
    "countryCodes": ["36"],
    "isoCode2": "HU",
    "isoCode3": "HUN",
    "phLength": 9
  },
  {
    "country": "Iceland",
    "countryCodes": ["354"],
    "isoCode2": "IS",
    "isoCode3": "ISL",
    "phLength": 9
  },
  {
    "country": "India",
    "countryCodes": ["91"],
    "isoCode2": "IN",
    "isoCode3": "IND",
    "phLength": 10
  },
  {
    "country": "Indonesia",
    "countryCodes": ["62"],
    "isoCode2": "ID",
    "isoCode3": "IDN",
    "phLength": 9
  },
  {
    "country": "Iran",
    "countryCodes": ["98"],
    "isoCode2": "IR",
    "isoCode3": "IRN",
    "phLength": 10
  },
  {
    "country": "Iraq",
    "countryCodes": ["964"],
    "isoCode2": "IQ",
    "isoCode3": "IRQ",
    "phLength": 10
  },
  {
    "country": "Ireland",
    "countryCodes": ["353"],
    "isoCode2": "IE",
    "isoCode3": "IRL",
    "phLength": 9
  },
  {
    "country": "Isle of Man",
    "countryCodes": ["44-1624"],
    "isoCode2": "IM",
    "isoCode3": "IMN",
    "phLength": 10
  },
  {
    "country": "Israel",
    "countryCodes": ["972"],
    "isoCode2": "IL",
    "isoCode3": "ISR",
    "phLength": 9
  },
  {
    "country": "Italy",
    "countryCodes": ["39"],
    "isoCode2": "IT",
    "isoCode3": "ITA",
    "phLength": 10
  },
  {
    "country": "Ivory Coast",
    "countryCodes": ["225"],
    "isoCode2": "CI",
    "isoCode3": "CIV"
  },
  {
    "country": "Jamaica",
    "countryCodes": ["1-876"],
    "isoCode2": "JM",
    "isoCode3": "JAM",
    "phLength": 10
  },
  {
    "country": "Japan",
    "countryCodes": ["81"],
    "isoCode2": "JP",
    "isoCode3": "JPN",
    "phLength": 10
  },
  {
    "country": "Jersey",
    "countryCodes": ["44-1534"],
    "isoCode2": "JE",
    "isoCode3": "JEY"
  },
  {
    "country": "Jordan",
    "countryCodes": ["962"],
    "isoCode2": "JO",
    "isoCode3": "JOR",
    "phLength": 9
  },
  {
    "country": "Kazakhstan",
    "countryCodes": ["7"],
    "isoCode2": "KZ",
    "isoCode3": "KAZ",
    "phLength": 10
  },
  {
    "country": "Kenya",
    "countryCodes": ["254"],
    "isoCode2": "KE",
    "isoCode3": "KEN",
    "phLength": 10
  },
  {
    "country": "Kiribati",
    "countryCodes": ["686"],
    "isoCode2": "KI",
    "isoCode3": "KIR",
    "phLength": 8
  },
  {
    "country": "Kosovo",
    "countryCodes": ["383"],
    "isoCode2": "XK",
    "isoCode3": "XKX"
  },
  {
    "country": "Kuwait",
    "countryCodes": ["965"],
    "isoCode2": "KW",
    "isoCode3": "KWT",
    "phLength": 8
  },
  {
    "country": "Kyrgyzstan",
    "countryCodes": ["996"],
    "isoCode2": "KG",
    "isoCode3": "KGZ",
    "phLength": 9
  },
  {
    "country": "Laos",
    "countryCodes": ["856"],
    "isoCode2": "LA",
    "isoCode3": "LAO",
    "phLength": 9
  },
  {
    "country": "Latvia",
    "countryCodes": ["371"],
    "isoCode2": "LV",
    "isoCode3": "LVA",
    "phLength": 8
  },
  {
    "country": "Lebanon",
    "countryCodes": ["961"],
    "isoCode2": "LB",
    "isoCode3": "LBN",
    "phLength": 7
  },
  {
    "country": "Lesotho",
    "countryCodes": ["266"],
    "isoCode2": "LS",
    "isoCode3": "LSO",
    "phLength": 8
  },
  {
    "country": "Liberia",
    "countryCodes": ["231"],
    "isoCode2": "LR",
    "isoCode3": "LBR",
    "phLength": 7
  },
  {
    "country": "Libya",
    "countryCodes": ["218"],
    "isoCode2": "LY",
    "isoCode3": "LBY",
    "phLength": 10
  },
  {
    "country": "Liechtenstein",
    "countryCodes": ["423"],
    "isoCode2": "LI",
    "isoCode3": "LIE",
    "phLength": 9
  },
  {
    "country": "Lithuania",
    "countryCodes": ["370"],
    "isoCode2": "LT",
    "isoCode3": "LTU",
    "phLength": 8
  },
  {
    "country": "Luxembourg",
    "countryCodes": ["352"],
    "isoCode2": "LU",
    "isoCode3": "LUX",
    "phLength": 9
  },
  {
    "country": "Macau",
    "countryCodes": ["853"],
    "isoCode2": "MO",
    "isoCode3": "MAC",
    "phLength": 8
  },
  {
    "country": "Macedonia",
    "countryCodes": ["389"],
    "isoCode2": "MK",
    "isoCode3": "MKD",
    "phLength": 8
  },
  {
    "country": "Madagascar",
    "countryCodes": ["261"],
    "isoCode2": "MG",
    "isoCode3": "MDG",
    "phLength": 10
  },
  {
    "country": "Malawi",
    "countryCodes": ["265"],
    "isoCode2": "MW",
    "isoCode3": "MWI",
    "phLength": 8
  },
  {
    "country": "Malaysia",
    "countryCodes": ["60"],
    "isoCode2": "MY",
    "isoCode3": "MYS",
    "phLength": 7
  },
  {
    "country": "Maldives",
    "countryCodes": ["960"],
    "isoCode2": "MV",
    "isoCode3": "MDV",
    "phLength": 7
  },
  {
    "country": "Mali",
    "countryCodes": ["223"],
    "isoCode2": "ML",
    "isoCode3": "MLI",
    "phLength": 8
  },
  {
    "country": "Malta",
    "countryCodes": ["356"],
    "isoCode2": "MT",
    "isoCode3": "MLT",
    "phLength": 8
  },
  {
    "country": "Marshall Islands",
    "countryCodes": ["692"],
    "isoCode2": "MH",
    "isoCode3": "MHL",
    "phLength": 7
  },
  {
    "country": "Mauritania",
    "countryCodes": ["222"],
    "isoCode2": "MR",
    "isoCode3": "MRT",
    "phLength": 7
  },
  {
    "country": "Mauritius",
    "countryCodes": ["230"],
    "isoCode2": "MU",
    "isoCode3": "MUS",
    "phLength": 8
  },
  {
    "country": "Mayotte",
    "countryCodes": ["262"],
    "isoCode2": "YT",
    "isoCode3": "MYT"
  },
  {
    "country": "Mexico",
    "countryCodes": ["52"],
    "isoCode2": "MX",
    "isoCode3": "MEX",
    "phLength": 10
  },
  {
    "country": "Micronesia",
    "countryCodes": ["691"],
    "isoCode2": "FM",
    "isoCode3": "FSM",
    "phLength": 7
  },
  {
    "country": "Moldova",
    "countryCodes": ["373"],
    "isoCode2": "MD",
    "isoCode3": "MDA",
    "phLength": 8
  },
  {
    "country": "Monaco",
    "countryCodes": ["377"],
    "isoCode2": "MC",
    "isoCode3": "MCO",
    "phLength": 9
  },
  {
    "country": "Mongolia",
    "countryCodes": ["976"],
    "isoCode2": "MN",
    "isoCode3": "MNG",
    "phLength": 8
  },
  {
    "country": "Montenegro",
    "countryCodes": ["382"],
    "isoCode2": "ME",
    "isoCode3": "MNE",
    "phLength": 8
  },
  {
    "country": "Montserrat",
    "countryCodes": ["1-664"],
    "isoCode2": "MS",
    "isoCode3": "MSR",
    "phLength": 10
  },
  {
    "country": "Morocco",
    "countryCodes": ["212"],
    "isoCode2": "MA",
    "isoCode3": "MAR",
    "phLength": 9
  },
  {
    "country": "Mozambique",
    "countryCodes": ["258"],
    "isoCode2": "MZ",
    "isoCode3": "MOZ",
    "phLength": 12
  },
  {
    "country": "Myanmar",
    "countryCodes": ["95"],
    "isoCode2": "MM",
    "isoCode3": "MMR",
    "phLength": 8
  },
  {
    "country": "Namibia",
    "countryCodes": ["264"],
    "isoCode2": "NA",
    "isoCode3": "NAM",
    "phLength": 10
  },
  {
    "country": "Nauru",
    "countryCodes": ["674"],
    "isoCode2": "NR",
    "isoCode3": "NRU",
    "phLength": 7
  },
  {
    "country": "Nepal",
    "countryCodes": ["977"],
    "isoCode2": "NP",
    "isoCode3": "NPL",
    "phLength": 10
  },
  {
    "country": "Netherlands",
    "countryCodes": ["31"],
    "isoCode2": "NL",
    "isoCode3": "NLD",
    "phLength": 9
  },
  {
    "country": "Netherlands Antilles",
    "countryCodes": ["599"],
    "isoCode2": "AN",
    "isoCode3": "ANT",
    "phLength": 8
  },
  {
    "country": "New Caledonia",
    "countryCodes": ["687"],
    "isoCode2": "NC",
    "isoCode3": "NCL",
    "phLength": 6
  },
  {
    "country": "New Zealand",
    "countryCodes": ["64"],
    "isoCode2": "NZ",
    "isoCode3": "NZL",
    "phLength": 9
  },
  {
    "country": "Nicaragua",
    "countryCodes": ["505"],
    "isoCode2": "NI",
    "isoCode3": "NIC",
    "phLength": 8
  },
  {
    "country": "Niger",
    "countryCodes": ["227"],
    "isoCode2": "NE",
    "isoCode3": "NER",
    "phLength": 8
  },
  {
    "country": "Nigeria",
    "countryCodes": ["234"],
    "isoCode2": "NG",
    "isoCode3": "NGA",
    "phLength": 8
  },
  {
    "country": "Niue",
    "countryCodes": ["683"],
    "isoCode2": "NU",
    "isoCode3": "NIU",
    "phLength": 4
  },
  {
    "country": "North Korea",
    "countryCodes": ["850"],
    "isoCode2": "KP",
    "isoCode3": "PRK",
    "phLength": 10
  },
  {
    "country": "Northern Mariana Islands",
    "countryCodes": ["1-670"],
    "isoCode2": "MP",
    "isoCode3": "MNP",
    "phLength": 10
  },
  {
    "country": "Norway",
    "countryCodes": ["47"],
    "isoCode2": "NO",
    "isoCode3": "NOR",
    "phLength": 8
  },
  {
    "country": "Oman",
    "countryCodes": ["968"],
    "isoCode2": "OM",
    "isoCode3": "OMN",
    "phLength": 8
  },
  {
    "country": "Pakistan",
    "countryCodes": ["92"],
    "isoCode2": "PK",
    "isoCode3": "PAK",
    "phLength": 10
  },
  {
    "country": "Palau",
    "countryCodes": ["680"],
    "isoCode2": "PW",
    "isoCode3": "PLW",
    "phLength": 7
  },
  {
    "country": "Palestine",
    "countryCodes": ["970"],
    "isoCode2": "PS",
    "isoCode3": "PSE"
  },
  {
    "country": "Panama",
    "countryCodes": ["507"],
    "isoCode2": "PA",
    "isoCode3": "PAN",
    "phLength": 8
  },
  {
    "country": "Papua New Guinea",
    "countryCodes": ["675"],
    "isoCode2": "PG",
    "isoCode3": "PNG",
    "phLength": 11
  },
  {
    "country": "Paraguay",
    "countryCodes": ["595"],
    "isoCode2": "PY",
    "isoCode3": "PRY",
    "phLength": 9
  },
  {
    "country": "Peru",
    "countryCodes": ["51"],
    "isoCode2": "PE",
    "isoCode3": "PER",
    "phLength": 9
  },
  {
    "country": "Philippines",
    "countryCodes": ["63"],
    "isoCode2": "PH",
    "isoCode3": "PHL",
    "phLength": 10
  },
  {
    "country": "Pitcairn",
    "countryCodes": ["64"],
    "isoCode2": "PN",
    "isoCode3": "PCN"
  },
  {
    "country": "Poland",
    "countryCodes": ["48"],
    "isoCode2": "PL",
    "isoCode3": "POL",
    "phLength": 9
  },
  {
    "country": "Portugal",
    "countryCodes": ["351"],
    "isoCode2": "PT",
    "isoCode3": "PRT",
    "phLength": 9
  },
  {
    "country": "Puerto Rico",
    "countryCodes": ["1-787", "1-939"],
    "isoCode2": "PR",
    "isoCode3": "PRI",
    "phLength": 10
  },
  {
    "country": "Qatar",
    "countryCodes": ["974"],
    "isoCode2": "QA",
    "isoCode3": "QAT",
    "phLength": 8
  },
  {
    "country": "Republic of the Congo",
    "countryCodes": ["242"],
    "isoCode2": "CG",
    "isoCode3": "COG",
    "phLength": 7
  },
  {
    "country": "Reunion",
    "countryCodes": ["262"],
    "isoCode2": "RE",
    "isoCode3": "REU"
  },
  {
    "country": "Romania",
    "countryCodes": ["40"],
    "isoCode2": "RO",
    "isoCode3": "ROU",
    "phLength": 10
  },
  {
    "country": "Russia",
    "countryCodes": ["7"],
    "isoCode2": "RU",
    "isoCode3": "RUS",
    "phLength": 10
  },
  {
    "country": "Rwanda",
    "countryCodes": ["250"],
    "isoCode2": "RW",
    "isoCode3": "RWA",
    "phLength": 9
  },
  {
    "country": "Saint Barthelemy",
    "countryCodes": ["590"],
    "isoCode2": "BL",
    "isoCode3": "BLM"
  },
  {
    "country": "Saint Helena",
    "countryCodes": ["290"],
    "isoCode2": "SH",
    "isoCode3": "SHN",
    "phLength": 4
  },
  {
    "country": "Saint Kitts and Nevis",
    "countryCodes": ["1-869"],
    "isoCode2": "KN",
    "isoCode3": "KNA",
    "phLength": 10
  },
  {
    "country": "Saint Lucia",
    "countryCodes": ["1-758"],
    "isoCode2": "LC",
    "isoCode3": "LCA",
    "phLength": 10
  },
  {
    "country": "Saint Martin",
    "countryCodes": ["590"],
    "isoCode2": "MF",
    "isoCode3": "MAF"
  },
  {
    "country": "Saint Pierre and Miquelon",
    "countryCodes": ["508"],
    "isoCode2": "PM",
    "isoCode3": "SPM",
    "phLength": 6
  },
  {
    "country": "Saint Vincent and the Grenadines",
    "countryCodes": ["1-784"],
    "isoCode2": "VC",
    "isoCode3": "VCT",
    "phLength": 10
  },
  {
    "country": "Samoa",
    "countryCodes": ["685"],
    "isoCode2": "WS",
    "isoCode3": "WSM",
    "phLength": 5
  },
  {
    "country": "San Marino",
    "countryCodes": ["378"],
    "isoCode2": "SM",
    "isoCode3": "SMR",
    "phLength": 10
  },
  {
    "country": "Sao Tome and Principe",
    "countryCodes": ["239"],
    "isoCode2": "ST",
    "isoCode3": "STP",
    "phLength": 7
  },
  {
    "country": "Saudi Arabia",
    "countryCodes": ["966"],
    "isoCode2": "SA",
    "isoCode3": "SAU",
    "phLength": 9
  },
  {
    "country": "Senegal",
    "countryCodes": ["221"],
    "isoCode2": "SN",
    "isoCode3": "SEN",
    "phLength": 9
  },
  {
    "country": "Serbia",
    "countryCodes": ["381"],
    "isoCode2": "RS",
    "isoCode3": "SRB",
    "phLength": 8
  },
  {
    "country": "Seychelles",
    "countryCodes": ["248"],
    "isoCode2": "SC",
    "isoCode3": "SYC",
    "phLength": 6
  },
  {
    "country": "Sierra Leone",
    "countryCodes": ["232"],
    "isoCode2": "SL",
    "isoCode3": "SLE",
    "phLength": 8
  },
  {
    "country": "Singapore",
    "countryCodes": ["65"],
    "isoCode2": "SG",
    "isoCode3": "SGP",
    "phLength": 8
  },
  {
    "country": "Sint Maarten",
    "countryCodes": ["1-721"],
    "isoCode2": "SX",
    "isoCode3": "SXM",
    "phLength": 10
  },
  {
    "country": "Slovakia",
    "countryCodes": ["421"],
    "isoCode2": "SK",
    "isoCode3": "SVK",
    "phLength": 9
  },
  {
    "country": "Slovenia",
    "countryCodes": ["386"],
    "isoCode2": "SI",
    "isoCode3": "SVN",
    "phLength": 8
  },
  {
    "country": "Solomon Islands",
    "countryCodes": ["677"],
    "isoCode2": "SB",
    "isoCode3": "SLB",
    "phLength": 7
  },
  {
    "country": "Somalia",
    "countryCodes": ["252"],
    "isoCode2": "SO",
    "isoCode3": "SOM",
    "phLength": 8
  },
  {
    "country": "South Africa",
    "countryCodes": ["27"],
    "isoCode2": "ZA",
    "isoCode3": "ZAF",
    "phLength": 9
  },
  {
    "country": "South Korea",
    "countryCodes": ["82"],
    "isoCode2": "KR",
    "isoCode3": "KOR",
    "phLength": 10
  },
  {
    "country": "South Sudan",
    "countryCodes": ["211"],
    "isoCode2": "SS",
    "isoCode3": "SSD",
    "phLength": 9
  },
  {
    "country": "Spain",
    "countryCodes": ["34"],
    "isoCode2": "ES",
    "isoCode3": "ESP",
    "phLength": 9
  },
  {
    "country": "Sri Lanka",
    "countryCodes": ["94"],
    "isoCode2": "LK",
    "isoCode3": "LKA",
    "phLength": 7
  },
  {
    "country": "Sudan",
    "countryCodes": ["249"],
    "isoCode2": "SD",
    "isoCode3": "SDN",
    "phLength": 9
  },
  {
    "country": "Suriname",
    "countryCodes": ["597"],
    "isoCode2": "SR",
    "isoCode3": "SUR",
    "phLength": 7
  },
  {
    "country": "Svalbard and Jan Mayen",
    "countryCodes": ["47"],
    "isoCode2": "SJ",
    "isoCode3": "SJM"
  },
  {
    "country": "Swaziland",
    "countryCodes": ["268"],
    "isoCode2": "SZ",
    "isoCode3": "SWZ",
    "phLength": 8
  },
  {
    "country": "Sweden",
    "countryCodes": ["46"],
    "isoCode2": "SE",
    "isoCode3": "SWE",
    "phLength": 7
  },
  {
    "country": "Switzerland",
    "countryCodes": ["41"],
    "isoCode2": "CH",
    "isoCode3": "CHE",
    "phLength": 9
  },
  {
    "country": "Syria",
    "countryCodes": ["963"],
    "isoCode2": "SY",
    "isoCode3": "SYR",
    "phLength": 9
  },
  {
    "country": "Taiwan",
    "countryCodes": ["886"],
    "isoCode2": "TW",
    "isoCode3": "TWN",
    "phLength": 9
  },
  {
    "country": "Tajikistan",
    "countryCodes": ["992"],
    "isoCode2": "TJ",
    "isoCode3": "TJK",
    "phLength": 9
  },
  {
    "country": "Tanzania",
    "countryCodes": ["255"],
    "isoCode2": "TZ",
    "isoCode3": "TZA",
    "phLength": 6
  },
  {
    "country": "Thailand",
    "countryCodes": ["66"],
    "isoCode2": "TH",
    "isoCode3": "THA",
    "phLength": 9
  },
  {
    "country": "Togo",
    "countryCodes": ["228"],
    "isoCode2": "TG",
    "isoCode3": "TGO",
    "phLength": 8
  },
  {
    "country": "Tokelau",
    "countryCodes": ["690"],
    "isoCode2": "TK",
    "isoCode3": "TKL",
    "phLength": 4
  },
  {
    "country": "Tonga",
    "countryCodes": ["676"],
    "isoCode2": "TO",
    "isoCode3": "TON",
    "phLength": 7
  },
  {
    "country": "Trinidad and Tobago",
    "countryCodes": ["1-868"],
    "isoCode2": "TT",
    "isoCode3": "TTO",
    "phLength": 10
  },
  {
    "country": "Tunisia",
    "countryCodes": ["216"],
    "isoCode2": "TN",
    "isoCode3": "TUN",
    "phLength": 8
  },
  {
    "country": "Turkey",
    "countryCodes": ["90"],
    "isoCode2": "TR",
    "isoCode3": "TUR",
    "phLength": 10
  },
  {
    "country": "Turkmenistan",
    "countryCodes": ["993"],
    "isoCode2": "TM",
    "isoCode3": "TKM",
    "phLength": 8
  },
  {
    "country": "Turks and Caicos Islands",
    "countryCodes": ["1-649"],
    "isoCode2": "TC",
    "isoCode3": "TCA",
    "phLength": 10
  },
  {
    "country": "Tuvalu",
    "countryCodes": ["688"],
    "isoCode2": "TV",
    "isoCode3": "TUV",
    "phLength": 6
  },
  {
    "country": "U.S. Virgin Islands",
    "countryCodes": ["1-340"],
    "isoCode2": "VI",
    "isoCode3": "VIR",
    "phLength": 7
  },
  {
    "country": "Uganda",
    "countryCodes": ["256"],
    "isoCode2": "UG",
    "isoCode3": "UGA",
    "phLength": 9
  },
  {
    "country": "Ukraine",
    "countryCodes": ["380"],
    "isoCode2": "UA",
    "isoCode3": "UKR",
    "phLength": 9
  },
  {
    "country": "United Arab Emirates",
    "countryCodes": ["971"],
    "isoCode2": "AE",
    "isoCode3": "ARE",
    "phLength": 9
  },
  {
    "country": "United Kingdom",
    "countryCodes": ["44"],
    "isoCode2": "GB",
    "isoCode3": "GBR",
    "phLength": 10
  },
  {
    "country": "United States",
    "countryCodes": ["1"],
    "isoCode2": "US",
    "isoCode3": "USA",
    "phLength": 10
  },
  {
    "country": "Uruguay",
    "countryCodes": ["598"],
    "isoCode2": "UY",
    "isoCode3": "URY",
    "phLength": 11
  },
  {
    "country": "Uzbekistan",
    "countryCodes": ["998"],
    "isoCode2": "UZ",
    "isoCode3": "UZB",
    "phLength": 9
  },
  {
    "country": "Vanuatu",
    "countryCodes": ["678"],
    "isoCode2": "VU",
    "isoCode3": "VUT",
    "phLength": 7
  },
  {
    "country": "Vatican",
    "countryCodes": ["379"],
    "isoCode2": "VA",
    "isoCode3": "VAT"
  },
  {
    "country": "Venezuela",
    "countryCodes": ["58"],
    "isoCode2": "VE",
    "isoCode3": "VEN",
    "phLength": 7
  },
  {
    "country": "Vietnam",
    "countryCodes": ["84"],
    "isoCode2": "VN",
    "isoCode3": "VNM",
    "phLength": 9
  },
  {
    "country": "Wallis and Futuna",
    "countryCodes": ["681"],
    "isoCode2": "WF",
    "isoCode3": "WLF",
    "phLength": 6
  },
  {
    "country": "Western Sahara",
    "countryCodes": ["212"],
    "isoCode2": "EH",
    "isoCode3": "ESH"
  },
  {
    "country": "Yemen",
    "countryCodes": ["967"],
    "isoCode2": "YE",
    "isoCode3": "YEM",
    "phLength": 9
  },
  {
    "country": "Zambia",
    "countryCodes": ["260"],
    "isoCode2": "ZM",
    "isoCode3": "ZMB",
    "phLength": 9
  },
  {
    "country": "Zimbabwe",
    "countryCodes": ["263"],
    "isoCode2": "ZW",
    "isoCode3": "ZWE",
    "phLength": 9
  }
]
